import { useState } from "react";
import { Link, useNavigate } from "react-router";
import ProfileForm from "@app/components/ProfileForm";
import useUser from "@app/zustand/user";

export default function WelcomeLoginProfile() {
  const me = useUser((state) => state.user!);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <span className="mb-4 text-2xl text-sky-800">Vous pouvez désormais finir votre inscription.</span>
      <ProfileForm
        defaultValues={me}
        className="max-w-md"
        id="onboarding-form"
        onOk={() => {
          navigate("/");
        }}
        setLoading={setLoading}
      />

      <div className="w-full py-5">
        En cliquant sur "Commencer", vous acceptez les{" "}
        <Link className="inline text-sky-800" to="/cgus">
          Conditions Générales d'Utilisation
        </Link>{" "}
        et la{" "}
        <Link className="text-sky-800" to="/confidentialité">
          Politique de Confidentialité
        </Link>
        .
      </div>
      <div className="flex w-full items-center justify-center py-5">
        <button
          className="mx-auto shrink-0 rounded-lg border-none bg-sky-800 px-5 py-1 text-white disabled:pointer-events-none disabled:opacity-30"
          type="submit"
          form="onboarding-form"
          disabled={loading}
        >
          {loading ? "Chargement..." : "Commencer"}
        </button>
      </div>
    </>
  );
}
